var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	78068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"200":1,"659":1,"744":1,"977":1,"1619":1,"1668":1,"1701":1,"1746":1,"2047":1,"2052":1,"2366":1,"2585":1,"5151":1,"6115":1,"6235":1,"6651":1,"6758":1,"7017":1,"7219":1,"7264":1,"7525":1,"7613":1,"7734":1,"8012":1,"8982":1,"9185":1,"9578":1,"11649":1,"12158":1,"12325":1,"12330":1,"14089":1,"15292":1,"16229":1,"16268":1,"16768":1,"17155":1,"17737":1,"17939":1,"18354":1,"18489":1,"18781":1,"18804":1,"19492":1,"20125":1,"20431":1,"20552":1,"20982":1,"21599":1,"21773":1,"21823":1,"22032":1,"22077":1,"22243":1,"22504":1,"22579":1,"23238":1,"23246":1,"23970":1,"24240":1,"24406":1,"24535":1,"25594":1,"25838":1,"26376":1,"26457":1,"26513":1,"26590":1,"27575":1,"27595":1,"27759":1,"28230":1,"28734":1,"28880":1,"29368":1,"30297":1,"30744":1,"30976":1,"31041":1,"31710":1,"31908":1,"31941":1,"31997":1,"32095":1,"32309":1,"32763":1,"32950":1,"33011":1,"33165":1,"33185":1,"33571":1,"33939":1,"34260":1,"34932":1,"35151":1,"35235":1,"35251":1,"35333":1,"35379":1,"35420":1,"35715":1,"36226":1,"36248":1,"36283":1,"36379":1,"36546":1,"36677":1,"36700":1,"36719":1,"36926":1,"36965":1,"37471":1,"37828":1,"38087":1,"38922":1,"39895":1,"40016":1,"40084":1,"40449":1,"40768":1,"41525":1,"41613":1,"41636":1,"41850":1,"41859":1,"41940":1,"42939":1,"43227":1,"43522":1,"43859":1,"43869":1,"44185":1,"44249":1,"45286":1,"45453":1,"45847":1,"46003":1,"46601":1,"46975":1,"47976":1,"48058":1,"48264":1,"48751":1,"49235":1,"49340":1,"50100":1,"50164":1,"50829":1,"51375":1,"51984":1,"52109":1,"54639":1,"55127":1,"55168":1,"55918":1,"56185":1,"57266":1,"57641":1,"58219":1,"58343":1,"58427":1,"59129":1,"59367":1,"59653":1,"59734":1,"59898":1,"60459":1,"61068":1,"61325":1,"61766":1,"61859":1,"62761":1,"62870":1,"63164":1,"63459":1,"63692":1,"63777":1,"64052":1,"64133":1,"64300":1,"64344":1,"64558":1,"64694":1,"64751":1,"64819":1,"64923":1,"65738":1,"66548":1,"66924":1,"67115":1,"67137":1,"67288":1,"67916":1,"68085":1,"68197":1,"69173":1,"69186":1,"69297":1,"69669":1,"70106":1,"70499":1,"70667":1,"70938":1,"71162":1,"71391":1,"71488":1,"71974":1,"73223":1,"73419":1,"73835":1,"74519":1,"74777":1,"76165":1,"76356":1,"77100":1,"77977":1,"79354":1,"79359":1,"79896":1,"80018":1,"80963":1,"81281":1,"81512":1,"81651":1,"81859":1,"81997":1,"82341":1,"82373":1,"83384":1,"84553":1,"84684":1,"85160":1,"87021":1,"88125":1,"88431":1,"88777":1,"88827":1,"89078":1,"89204":1,"89255":1,"89342":1,"90632":1,"90955":1,"91507":1,"91793":1,"91795":1,"91946":1,"92793":1,"92965":1,"93806":1,"93894":1,"95097":1,"95627":1,"95978":1,"96699":1,"96924":1,"97546":1,"97699":1,"98757":1,"98779":1,"98980":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr